import { Avatar, List, message, ConfigProvider, Modal, Button } from "antd";
import { useEffect, useState } from "react";
import { getPDF, getAPI } from "../../../config/api/apiConfig";
import { useSelector } from "react-redux";

const VendorDownloadCertificate = ({ activeKey }) => {
  const [loading, setLoading] = useState(false);
  const [deviceList, setDeviceList] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [certificateUrl, setCertificateUrl] = useState('');
  const userId = useSelector((state) => state.authenticate.userId);

  const getUserDevice = async () => {
    try {
      setLoading(true);
      const response = await getAPI(
        `/get-user-device-approved-status/${userId}`
      );
      const { success, data } = response.data;
      console.log("STATUS", data);
      setDeviceList(data);
      setLoading(false);
    } catch (error) {
      console.log("Error:", error);
      setLoading(false);
      message.error(error.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUserDevice();
  }, [activeKey]);

  const downloadCertificate = async (
    deviceId,
    organisationName,
    deviceName,
    deviceModel,
    fileName
  ) => {
    try {
      const response = await getPDF(
        `/download-device-certificate/${deviceId}/${organisationName}/${deviceName}/${deviceModel}`,
        { responseType: "blob" }
      );
      console.log("Response:", response);
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      
      // Trigger download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      link.click();
    } catch (error) {
      console.log("Error:", error);
      message.error(error.response?.data?.message);
    }
  };

  const printCertificate = async (
    deviceId,
    organisationName,
    deviceName,
    deviceModel,
    fileName
  ) => {
    try {
      const response = await getPDF(
        `/download-device-certificate/${deviceId}/${organisationName}/${deviceName}/${deviceModel}`,
        { responseType: "blob" }
      );
      console.log("Response:", response);
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      setCertificateUrl(url);
      setModalVisible(true);
    } catch (error) {
      console.log("Error:", error);
      message.error(error.response?.data?.message);
    }
  };

  const handleCancel = () => {
    setModalVisible(false);
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "white",
        },
      }}
    >
      <List
        className="demo-loadmore-list"
        loading={loading}
        itemLayout="horizontal"
        dataSource={deviceList}
        renderItem={(item) => (
          <List.Item
            actions={[
              <Button
                key="list-loadmore-download"
                type="primary"
                onClick={() =>
                  downloadCertificate(
                    item.id,
                    item.organisationName,
                    item.deviceName,
                    item.deviceModel,
                    "Device Certificate"
                  )
                }
              >
                Download
              </Button>,
              <Button
                key="list-loadmore-view"
                onClick={() =>
                  printCertificate(
                    item.id,
                    item.organisationName,
                    item.deviceName,
                    item.deviceModel,
                    "Device Certificate"
                  )
                }
              >
                View Certificate
              </Button>,
            ]}
          >
            <List.Item.Meta
              avatar={<Avatar src={item.avatar} />}
              title={item.deviceName || "Device Name"}
              description={`${item.organisationName} added ${item.deviceModel} on ${item.createdAt.slice(0, 10)}`}
            />
          </List.Item>
        )}
      />
      <Modal
        title="Certificate Preview"
        visible={modalVisible}
        onCancel={handleCancel}
        width="75%"
        footer={[
          <Button style={{marginRight:"0.8em"}} key="cancel" onClick={handleCancel}>Cancel</Button>,
          <a key="download" href={certificateUrl} download="Device_Certificate.pdf">
            <Button type="primary">Download</Button>
          </a>
        ]}
      >
        <embed src={certificateUrl} type="application/pdf" width="100%" height="500px" />
      </Modal>
    </ConfigProvider>
  );
};

export default VendorDownloadCertificate;
